import React from 'react';

import {
  MainContainer,
  Input,
  RightElementContainer
} from './text-input.styles';

const TextInput = ({
  id,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  rightElement, // Optional element like an icon or button
  disabled = false,
}) => {
  return (
    <MainContainer>
      <Input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
      />
      {rightElement && <RightElementContainer>{rightElement}</RightElementContainer>}
    </MainContainer>
  );
};

export default TextInput;